import { Routes, Route, Navigate } from "react-router-dom";
import { UserProvider } from "./Context/UserContext";
import React, { useEffect, useState } from "react";
import { FullPageSpinner } from "./Common/FullPageSpinner";
import { ConfigProvider } from "antd";
import ApplicationState from "./CapsitechInventoryComponents/Context/ApplicationContext/ApplicationState";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import en_US from "antd/locale/en_US";
import { useSelector } from "react-redux";
import { isAuthenticated as isAuth } from "./store/slice/userslice";
import { listenForAuthEvents } from "./Utilities/AuthBroadcast";
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 1,
    },
  },
});

const UnauthorizedRoutePath = React.lazy(
  () => import("./CapsitechInventoryComponents/Routes/UnauthorizedRoutePath")
);
const AuthorizedRoutePath = React.lazy(
  () => import("./CapsitechInventoryComponents/Common/WrapperInventory")
);

const App = () => {
  const isAuthenticated = useSelector(isAuth);
  const [authEvent, setAuthEvent] = useState<"LOGIN" | "LOGOUT" | null>(null);

  useEffect(() => {
    const unsubscribe = listenForAuthEvents(
      () => setAuthEvent("LOGIN"),
      () => setAuthEvent("LOGOUT")
    );
    return unsubscribe;
  }, []);

  useEffect(() => {
    if (authEvent) {
      // window.location.reload();
    }
  }, [authEvent]);

  return (
    <UserProvider>
      <ApplicationState>
        <ConfigProvider
          locale={en_US}
          theme={{
            components: {
              Menu: {
                darkSubMenuItemBg: " rgb(253, 12, 148)",
                darkItemBg: "rgb(39, 0, 41)",
                colorText: "#001440",
              },
              Table: {
                // fontSize: 14,
                fontWeightStrong: 500,
                // lineHeight: 1,
                // lineWidth: 0,
                // lineType: "dashed",
                rowSelectedBg: "#f8f8f8",
                rowSelectedHoverBg: "#f8f8f8",
                rowHoverBg: "#f8f8f8",
                padding: 6,
                paddingContentVerticalLG: 6,
                algorithm: true,
                colorFillAlter: "#F8FAFE",

                // borderRadius: 0,
                // algorithm: true,
              },
              Badge: {
                colorSuccess: "#40d824",
                colorWarning: "#FF9100",
                colorError: "#FF0000",
                algorithm: true,
              },
              Button: {
                fontSize: 13,
                colorErrorActive: "rgb(221,42,59)",
                colorError: "rgb(221,42,59)",
                // borderRadius: 4,
              },
              Input: {
                colorTextPlaceholder: "#1B1A1A",
                colorFillAlter: "transparent",

                fontSize: 13,
                // controlHeight: 28,
                // borderRadius: 1,
                algorithm: true,
              },
              DatePicker: {
                colorTextPlaceholder: "#1B1A1A",
                algorithm: true,
                // fontSize: 13,
                // controlHeight: 28,
                // borderRadius: 1,
              },
              Select: {
                colorTextPlaceholder: "#1B1A1A",
                fontSize: 13,
                // fontSize: 14,
                // controlHeight: 28,
                // borderRadius: 1,
                algorithm: true,
                fontWeightStrong: 600,
              },
              Pagination: {
                borderRadius: 1,
                algorithm: true,
                itemSize: 28,
                fontSize: 13,
                margin: 4,
              },
              Anchor: {
                colorPrimary: "transparent",
                colorBgContainer: "red",
                colorText: "#646773",
                fontSize: 14,
                colorSplit: "transparent",
                linkPaddingInlineStart: 1,
              },
              Typography: {
                colorText: "#181C2E",
              },
              Progress: {
                remainingColor: "#E6F4FF",
                defaultColor: "#69B1FF",
                lineBorderRadius: 1.7,
              },
              Card: {
                bodyPadding: 5,
              },
            },
            token: {
              // fontFamily: "Open Sans, sans-serif",
              fontFamily: "Poppins , sans-serif",
              colorPrimary: "#c7263a",
              colorInfo: "#c7263a",
            },
          }}
        >
          <QueryClientProvider client={queryClient}>
            <React.Suspense fallback={<FullPageSpinner />}>
              <Routes>
                {isAuthenticated ? (
                  <>
                    <Route
                      element={<AuthorizedRoutePath />}
                      path="/inventory/*"
                    />
                    {/* Redirects any unmatched route to the dashboard if the path does not match "/inventory" */}
                    <Route
                      path="*"
                      element={<Navigate to="/inventory" replace />}
                    />
                  </>
                ) : (
                  <Route element={<UnauthorizedRoutePath />} path="/*" />
                )}

                {/* 
                <Route element={<WrapperInventory />} path="/inventory/*" />
                */}
                {/* <Route element={<AsyncWrapperInventory />} path="/inventory/*" /> */}
              </Routes>
            </React.Suspense>
            {/* <ReactQueryDevtools buttonPosition="" initialIsOpen={false} /> */}
          </QueryClientProvider>
        </ConfigProvider>
      </ApplicationState>
    </UserProvider>
  );
};

export default App;
